import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type TopbarPairCountProps = {
  count: number
  isLoading?: boolean
} & ClassNameProps

export const TopbarPairCount: React.FC<TopbarPairCountProps> = ({
  className,
  count,
  isLoading,
}) => {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <Root className={className}>
        <Skeleton width={22} height={22} />
      </Root>
    )
  }

  return (
    <Root className={className}>
      <Badge>{count}</Badge>
      <Label>{t('position', { count })}</Label>
    </Root>
  )
}

const Root = styled.div`
  height: 26px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;

  padding-inline: 2px 7px;
  border-radius: 6px;
  background: var(--background-1);
`

const Badge = styled.div`
  min-width: 22px;
  height: 22px;
  padding-inline: 5px;
  cursor: default;

  border-radius: 6px;
  border: 1px solid var(--background-7);

  font-size: 11px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`

const Label = styled.div`
  font-size: 11px;
  font-weight: 600;
  line-height: 20px;
  cursor: default;
`
